import React from 'react'
import "./banner.css"
const NewBanner = ({setShow}) => {
  return (
    <>
        <div className='banner-img h-[100%] w-full max-sm:h-[100%]'>
      
        <div class="custom-shape-divider-bottom-1709136912">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
    </svg>
</div>

        <div className=' flex items-center justify-center h-[100%] w-full flex-col gap-16 max-sm:h-[100%]'>
          <h1 className=' text-5xl font-bold text-white max-sm:text-xl  max-sm:text-center max-md:text-3xl uppercase h1'>Welcome To SocioLoom</h1>
          <p className=' text-white max-sm:text-center uppercase text-xl max-sm:text-sm p'>Your Vission <span className=' text-[#07c991a8] text-2xl'>|</span> Our Code</p>
          <button className=' py-3.5 px-10 bg-[#07c991a8] text-white rounded outline-none focus:outline-none' onClick={()=>setShow(true)}>Find Out More</button>
        </div>
        </div>
        
    </>
  )
}

export default NewBanner
